import {Alert} from "@/components/ui/index.js";
import {CircleHelp} from "lucide-react";
import {AlertDescription, AlertTitle} from "@/components/ui/alert.js";
import React from "react";

const NeedHelpAlert = () => {

  return (
    <Alert>
      <CircleHelp className='h-4 w-4'/>
      <AlertTitle className="text-base font-semibold flex items-center gap-3">
        <span>
          Need Help?
        </span>
      </AlertTitle>
      <AlertDescription className="mt-2">
        If you have any questions about your application or need assistance
        starting a new one, please contact us at <span className='italic'>human@kay.ai</span>
      </AlertDescription>
    </Alert>
  )
}

export default NeedHelpAlert;
